import Hidden from '@material-ui/core/Hidden';
import { makeStyles } from '@material-ui/core/styles';
import chiliPepper from 'assets/img/icons/chili-pepper.svg';
import cowboyHat from 'assets/img/icons/cowboy-hat.svg';
import ticketsIconBackground from 'assets/img/ticket.svg';
import admissionStyle from 'assets/jss/material-kit-pro-react/views/landingPageSections/admissionStyle.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardFooter from 'components/Card/CardFooter.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import React from 'react';

const useStyles = makeStyles(admissionStyle);

export default function SectionAdmission() {
  const classes = useStyles();
  return (
    <div className={classes.section} id="admission">
      <div className={classes.container}>
        <GridContainer>
          <GridItem xs={12} sm={10} md={8} className={classes.admissionItem}>
            <h2 className={classes.title}>Admission Prices &amp; Tickets</h2>
            <h5 className={classes.description}>
              All proceeds benefit the Chilimania Scholarship Fund and other
              community-based projects and organizations. Scroll below for
              admissions information and tickets.
            </h5>
            <p className={classes.smallDescription}>
              <b>Note:</b> Country Edge and Chilimania are separate events and
              require separate admission tickets.
            </p>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <img
            className={classes.ticketsAlign}
            src={ticketsIconBackground}
            alt="Tickets Icon"
          />
          <GridItem md={4} implementation="css" smDown component={Hidden} />
          <GridItem xs={12} sm={6} md={4}>
            <Card className={classes.ticketCard} pricing>
              <CardBody pricing>
                <img
                  className={classes.customIcon}
                  src={cowboyHat}
                  alt={'Cowboy Hat Icon'}
                />
                <h3 className={classes.cardHeader}>COUNTRY EDGE</h3>
                <h5 className={classes.cardInfo}>General Admission</h5>
                <p className={classes.cardGeneralPrice}>TBA</p>
                <hr width={'80%'} />
                <p className={classes.cardInfo}>Children 10 &amp; Under</p>
                <p>Free with Adult</p>
                <p>Applies to general admission only!</p>
                <hr width={'80%'} />
                <p className={classes.cardInfo}>Dedicated VIP Area</p>
                <h5 className={classes.cardVipPrice}>TBA</h5>
                <hr width={'80%'} />
                <p className={classes.cardInfo}>
                  Online ticket sales are closed. General admission tickets are
                  still available at the gate.
                  {/* <br />
                  Pre-sale tickets available below. */}
                </p>
                {/* <Button
                  className={classes.ticketButton}
                  href="https://www.eventeny.com/events/ticket/?id=28844&ref=chilimania"
                  size="sm"
                  color="primary"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Purchase Country Edge tickets (opens in new tab)"
                >
                  Purchase Tickets Now
                  <ConfirmationNumberIcon />
                </Button> */}
              </CardBody>
              <CardFooter className={classes.justifyContentCenter} pricing>
                <p>*Processing fees may apply</p>
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={4} className={classes.mrAuto}>
            <Card className={classes.ticketCard} pricing>
              <CardBody pricing>
                <img
                  className={classes.customIcon}
                  src={chiliPepper}
                  alt={'Chili Pepper Icon'}
                />
                <h3 className={classes.cardHeader}>CHILIMANIA</h3>
                <h5 className={classes.cardInfo}>General Admission</h5>
                <p className={classes.cardGeneralPrice}>TBA</p>
                <hr width={'80%'} />
                <p className={classes.cardInfo}>Children 10 &amp; Under</p>
                <p>Free with Adult</p>
                <p>Applies to general admission only!</p>
                <hr width={'80%'} />
                <p className={classes.cardInfo}>Dedicated VIP Area</p>
                <h5 className={classes.cardVipPrice}>TBA</h5>
                <hr width={'80%'} />
                <p className={classes.cardInfo}>
                  Online ticket sales are closed. General admission tickets are
                  still available at the gate.
                  {/* <br />
                  Pre-sale tickets available below. */}
                </p>
                {/* <Button
                  className={classes.ticketButton}
                  href="https://www.eventeny.com/events/ticket/?id=28844&ref=chilimania"
                  size="sm"
                  color="primary"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Purchase Chilimania tickets (opens in new tab)"
                >
                  Purchase Tickets Now
                  <ConfirmationNumberIcon />
                </Button> */}
              </CardBody>
              <CardFooter className={classes.justifyContentCenter} pricing>
                <p>*Processing fees may apply</p>
              </CardFooter>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
